import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <div className="label-mono">Loading EAZYFLEET…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
